// extracted by mini-css-extract-plugin
module.exports = {"buttons":"_64162e9","empty":"_409f6f7","button":"_2317c12"};